import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProjects from './components/FeaturedProjects';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import QuoteSection from './components/QuoteSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NGP Renovatieproject",
      "url": `${import.meta.env.VITE_SITE_URL ?? ''}`,
      "description": "Professionele renovatiediensten in Antwerpen en omgeving. Specialist in appartement renovatie, badkamer verbouwing, keuken renovatie en complete woningtransformaties.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Adelaarstraat 55 B301",
        "addressLocality": "Merksem",
        "postalCode": "2170",
        "addressCountry": "BE"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 51.2397,
        "longitude": 4.4297
      },
      "areaServed": {
        "@type": "City",
        "name": "Antwerpen"
      },
      "serviceType": ["Renovatie", "Badkamer verbouwing", "Keuken renovatie", "Appartement renovatie"],
      "priceRange": "€€",
      "email": "ngp.renovatieprojecten@gmail.com",
      "sameAs": [],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "bestRating": "5",
        "worstRating": "1",
        "ratingCount": "6",
        "reviewCount": "6"
      },
      "review": [
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Sophie van der Berg" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "NGP heeft ons appartement volledig getransformeerd. De aandacht voor detail en vakmanschap waren uitzonderlijk. Zeer tevreden met het resultaat!",
          "datePublished": "2024-11-10",
          "name": "Appartement Renovatie"
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Mark Jansen" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "Professioneel team dat precies wist wat ze deden. De badkamer ziet er nu luxe en modern uit. Aanrader!",
          "datePublished": "2024-10-22",
          "name": "Badkamer Verbouwing"
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Lisa de Vries" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "Fantastisch werk! De nieuwe keuken overtreft al onze verwachtingen. Goede communicatie en netjes afgewerkt.",
          "datePublished": "2024-09-15",
          "name": "Keuken Renovatie"
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Peter Bakker" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "NGP heeft onze woonkamer omgetoverd tot een prachtige ruimte. Zeer vakkundig en betrouwbaar.",
          "datePublished": "2024-08-30",
          "name": "Woonkamer Renovatie"
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Emma Visser" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "Van begin tot eind perfect geregeld. Het team was professioneel en het eindresultaat is prachtig!",
          "datePublished": "2024-07-18",
          "name": "Complete Renovatie"
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Tom Hendriks" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "Uitstekende service en kwaliteit. Ze hebben ons kantoor getransformeerd naar een moderne werkruimte.",
          "datePublished": "2024-06-05",
          "name": "Kantoor Verbouwing"
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('schema-home');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <FeaturedProjects />
      <BeforeAfterGallery />
      <AboutSection />
      <TestimonialsSection />
      <QuoteSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
